import { $isElementNode, type ElementNode, type LexicalNode } from "lexical";

export function $findAllNodesOfType<T extends LexicalNode>(
  node: ElementNode,
  filterFn: (node: LexicalNode) => node is T,
): T[] {
  const children = node.getChildren();
  const elements = children.filter($isElementNode);
  const nodes = children.filter(filterFn);

  return nodes.concat(elements.flatMap((e) => $findAllNodesOfType(e, filterFn)));
}
